import { useState } from "react";

const usePost = <T>(url: string) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const post = async (payload: object | FormData) => {
    setLoading(true);
    setError(null);

    try {
      const isFormData = payload instanceof FormData;

      const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
        method: "POST",
        headers: isFormData ? undefined : { "Content-Type": "application/json" },
        body: isFormData ? payload : JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorBody = "";
        try {
          errorBody = await response.text();
        } catch (_) {}
        throw new Error(`HTTP error! status: ${response.status} — ${errorBody}`);
      }

      const result = await response.json();
      setData(result as T);
    } catch (err) {
      setError(err as Error);
      throw err; // re-throw so the caller's catch block triggers
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, post };
};

export default usePost;